<template>
  <div class="h-full flex flex-col">
    <div class="flex mb-10px flex-wrap">
      <el-input
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请输入关键字"
        v-model="searchData.keywords"
        clearable
      ></el-input>
      <el-button class="mb-10px" size="small" type="primary" @click="searchList">搜索</el-button>
      <el-button class="mb-10px" size="small" @click="resetText">重置</el-button>
      <!-- :disabled="!$hasAccess('create')" -->
      <el-button class="mb-10px" type="primary" size="small" @click="handleEvent(null, 'create')">
        新增
      </el-button>
      <el-button
        class="mb-10px"
        size="small"
        type="danger"
        :disabled="!$hasAccess('delete')"
        @click="handleEvent(null, 'batchDelete')"
        >删除</el-button
      >
      <el-button
        class="mb-10px"
        size="small"
        @click="handleEvent(null, 'batchImport')"
        :disabled="!$hasAccess('batchImport')"
        >导入</el-button
      >
      <!-- <el-button
        size="small"
        @click="handleEvent(null, 'batchExportQrCodePDF')"
        :disabled="!$hasAccess('batchExportQrCode')"
        >导出二维码</el-button
      > -->
    </div>
    <div class="flex-auto h-0px">
      <el-table
        :span-method="spanMethod"
        ref="table"
        :data="tableData"
        border
        class="w-full"
        :height="tableHeight"
        stripe
        v-loading="loading"
        @selection-change="handleSelection"
      >
        <!-- <el-table-column type="selection" width="50"></el-table-column> -->
        <el-table-column label="序号" prop="index" width="50"></el-table-column>
        <el-table-column
          label="基础管理排查项目"
          prop="screeningItemsName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="项目编码"
          prop="projectCode"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="排查内容"
          prop="screeningContent"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="排查标准"
          prop="screeningCriteria"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="组织级别" prop="organizationLevel" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ controlHierarchyMap(scope.row.organizationLevel) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="排查周期" prop="title" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ checkCycleText(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="排查类型" prop="screeningType" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ checkTypeMap(scope.row.screeningType) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click.native="handleEvent(scope.row, 'read')"
              :disabled="!$hasAccess('read')"
              >查看</el-button
            >
            <el-button
              size="mini"
              :disabled="!$hasAccess('update')"
              @click="handleEvent(scope.row, 'update')"
              >编辑</el-button
            >
            <el-button
              size="mini"
              @click.native="handleEvent(scope.row, 'delete')"
              :disabled="!$hasAccess('read')"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="searchList"
        @current-change="findList"
        :current-page.sync="pageNo"
        :page-size.sync="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :total="total"
        class="float-right mt-20px ml-10px"
      ></el-pagination>
    </div>
    <CheckListBaseForm
      v-if="formDialog"
      :formProps="formProps"
      :formData="formData"
      @refreshList="refreshList"
      @cancel="formDialog = false"
    ></CheckListBaseForm>
    <wiz-upload-file
      v-dialogDrag
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
      @exportResults="exportResults"
    ></wiz-upload-file>
  </div>
</template>

<script>
import { HiddenDangerInspectionChecklistControllApi } from '@wiz-api/double-prevention-management'
import uuid from 'uuid'
import { wizUploadFile } from '@wiz-core/compts'
import utils from '@/components/safety/enumField/utils'
import DownResultFile from '@/assets/js/safety/DownResultFile'
import CheckListBaseForm from './CheckListBaseForm'

const hiddenDangerInspectionChecklistControllApi = new HiddenDangerInspectionChecklistControllApi()

export default {
  name: 'check-list-base-table',
  mixins: [DownResultFile],
  components: {
    CheckListBaseForm,
    wizUploadFile,
  },
  filters: {},
  data() {
    return {
      formDialog: false,
      formData: {},
      checkTypeList: [],
      controlHierarchyList: [],
      unitCycleList: [],
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 0, // 目前状态页面0为下载模板 1为上传模板 2为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      id: '',
      formProps: {
        title: '新增基础排查清单',
        visible: true,
        // create 新增 update 编辑 read 详情
        editType: 'create',
      },
      jobAreaList: [],
      // 作业活动清单
      tableData: [],
      loading: false,
      searchData: {
        type: '',
        readStatus: '',
        title: '',
      },
      total: 0,
      pageNo: 1,
      pageSize: 15,
      selectionData: [],

      position: 0,
      spanArrObj: {},
    }
  },
  created() {
    this.searchList()
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.CheckType',
        'DoublePreventionManagement.DataCategory.ControlHierarchy',
        'DoublePreventionManagement.DataCategory.UnitCycle',
      ],
      ['checkTypeList', 'controlHierarchyList', 'unitCycleList'],
      this
    )
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 54px)'
    },
    checkTypeMap() {
      return (val) => {
        return (
          this.checkTypeList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    controlHierarchyMap() {
      return (val) => {
        return (
          this.controlHierarchyList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    checkCycleText() {
      return (row) => {
        if (row.inspectionCycle && `${row.unitCycle}`) {
          const unit =
            this.unitCycleList.find((i) => {
              // eslint-disable-next-line eqeqeq
              return i.code == row.unitCycle
            })?.displayName || ''
          return `${row.inspectionCycle}${unit}`
        }
        return ''
      }
    },
  },
  methods: {
    resetText() {
      this.searchData = this.$options.data().searchData
      this.searchList()
    },
    // 选中
    handleSelection(values) {
      this.selectionData = values.map((item) => {
        return item.id
      })
    },
    // 下载模板
    async exportTemplate() {
      const [
        err,
        res,
      ] = await hiddenDangerInspectionChecklistControllApi.downloadFoundationClassListFile({
        returnType: 'Blob',
      })
      if (!err) {
        this.downLoadExcel('隐患排查基础管理清单模板', res)
        this.$message({
          showClose: true,
          message: '模板下载成功',
          type: 'success',
        })
      }
    },
    downLoadExcel(fileName = '下载文件', data) {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `${fileName}`
      link.click()
      window.URL.revokeObjectURL(link.href)
    },
    // 上传文件
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append('input', value)
      })
      const [err, res] = await hiddenDangerInspectionChecklistControllApi.importFoundationClassList(
        {
          input: formData.get('input'),
        }
      )
      if (!err) {
        if (res.code === 1) {
          this.uploadFileProps.successCount = res.data?.numberSuccesses
          this.uploadFileProps.failureCount = res.data?.numberFailures
          // 如需兼容老样式，则resultFile字段为空或者不设置皆可
          this.uploadFileProps.resultFile = res.data?.fileId
          this.uploadFileProps.active = 2
          this.handleSearch()
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          })
        }
      }
      this.uploadFileProps.btnLoading = false
    },
    handleSearch() {
      this.searchList()
    },
    searchList() {
      this.pageNo = 1
      this.findList()
    },
    async findList() {
      this.loading = true
      const searchData = utils.deleteFormField(this.searchData)
      const data = {
        skipCount: (this.pageNo - 1) * this.pageSize,
        maxResultCount: this.pageSize,
        ...searchData,
      }
      const [err, res] = await hiddenDangerInspectionChecklistControllApi.getFoundationClassList(
        data
      )

      if (!err) {
        this.tableData = this.toList(res.items)
        this.getSpanArr()
        this.total = res.totalCount
        this.loading = false
      }
    },

    toList(list) {
      return list.reduce((pre, item, index) => {
        item.pid = item.id
        item.mergeId = uuid()
        const data = item.inspectionChecklistDtos
        if (data && data.length) {
          data.forEach((i) => {
            i.index = index + 1
            pre.push({
              ...item,
              ...i,
              inspectionChecklistDtos: item.inspectionChecklistDtos,
            })
          })
        } else {
          item.index = index + 1
          pre.push(item)
        }
        return pre
      }, [])
    },
    getSpanArr() {
      this.position = 0
      this.spanArrObj = {}
      const needSpan = ['mergeId']
      needSpan.forEach((item) => {
        this.rowspan(item)
      })
    },
    // 获取合并行参数(数组)
    rowspan(prop) {
      this.tableData.forEach((item, index) => {
        if (index === 0) {
          if (!this.spanArrObj[prop]) {
            this.spanArrObj[prop] = []
          }
          this.spanArrObj[prop].push(1)
          this.position = 0
        } else if (this.tableData[index][prop] === this.tableData[index - 1][prop]) {
          this.spanArrObj[prop][this.position] += 1
          this.spanArrObj[prop].push(0)
        } else {
          if (!this.spanArrObj[prop]) {
            this.spanArrObj[prop] = []
          }
          this.spanArrObj[prop].push(1)
          this.position = index
        }
      })
    },
    // 合并行方法
    spanMethod({ row, column, rowIndex, columnIndex }) {
      if ([0, 1, 2, 9].includes(columnIndex)) {
        const _row = this.spanArrObj.mergeId[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col,
        }
      }
      return {
        rowspan: 1,
        colspan: 1,
      }
    },
    refreshList() {
      this.findList()
    },
    // 列表操作-事件
    handleEvent(row = null, operation) {
      switch (operation) {
        case 'delete':
          this.$confirm('是否删除该记录？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              const [
                err,
                res,
              ] = await hiddenDangerInspectionChecklistControllApi.deleteFoundationClassList({
                guids: [row.pid],
              })
              if (!err) {
                this.$message.success('删除成功')
                this.findList()
              }
            })
            .catch(() => {})
          break
        case 'create':
          this.initDialog(row, operation)
          break
        case 'read':
          this.initDialog(row, operation)
          break
        case 'update':
          this.initDialog(row, operation)
          break
        case 'batchDelete':
          const selectionData = this.selectionData
          if (!selectionData || selectionData.length === 0) {
            this.$message({
              showClose: true,
              message: '请勾选要删除的记录',
              type: 'warning',
            })
            return
          }
          this.$confirm('是否批量删除勾选记录，删除后不可恢复？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              const [
                err,
                res,
              ] = await hiddenDangerInspectionChecklistControllApi.deleteFoundationClassList({
                guids: selectionData,
              })
              if (!err) {
                this.$message({
                  showClose: true,
                  message: '删除成功',
                  type: 'success',
                })
                this.findList()
              }
            })
            .catch(() => {})
          break
        case 'batchImport':
          this.uploadFileProps.active = 0
          this.uploadFileProps.visible = true
          break
        case 'batchExportQrCodePDF':
          if (!this.selectionData || this.selectionData.length === 0) {
            this.$message({
              showClose: true,
              message: '请勾选要导出的记录',
              type: 'warning',
            })
            return
          }
          this.gengQrCode()
          break
        default:
          break
      }
    },
    async gengQrCode() {
      const [err, res] = await hiddenDangerInspectionChecklistControllApi.gengQrCode({
        guids: this.selectionData,
        returnType: 'Blob',
      })
      if (!err) {
        this.$message({
          showClose: true,
          message: '导出成功',
          type: 'success',
        })
        const fileStream = this.base64ToBolb(res)
        this.exportFile(fileStream, '设备设施二维码')
      }
    },
    base64ToBolb(res) {
      const raw = window.atob(res)
      const rawLength = raw.length
      const uInt8Array = new Uint8Array(rawLength)
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i)
      }
      return new Blob([uInt8Array])
    },
    // 下载文件
    exportFile(data, name) {
      const blob = new Blob([data], {
        type: 'application/pdf',
      })
      const blobUrl = window.URL.createObjectURL(blob)
      const templink = document.createElement('a')
      templink.style.display = 'none'
      templink.href = blobUrl
      templink.setAttribute('download', `${name}`)
      document.body.appendChild(templink)
      templink.click()
      document.body.removeChild(templink)
      window.URL.revokeObjectURL(blobUrl)
    },
    // 弹窗初始化操作
    initDialog(row, operation) {
      // 没有新增获取数据
      this.id = row && row.id ? row.id : ''
      this.formProps.editType = operation
      this.formProps.title = `${
        // eslint-disable-next-line no-nested-ternary
        operation === 'create' ? '新增' : operation === 'update' ? '编辑' : '查看'
      }基础排查清单`
      if (operation === 'create') {
        this.formData = this.$options.data().formData
      } else {
        this.formData = row
      }
      this.formDialog = true
      this.formProps.visible = true
    },
  },
}
</script>

<style></style>
